// Colors - re-exports from Theme.ts for backwards compatibility
// New code should import from Theme directly
import Theme from "css/Theme";

// Re-export Theme as Colors for backwards compatibility
export const Colors = {
	main1: Theme.main1,
	main2: Theme.main2,
	main3: Theme.main3,
	main4: Theme.main4,
	main1light: Theme.main1light,
	main2light: Theme.main2light,
	main3light: Theme.main3light,
	main4light: Theme.main4light,
	error: Theme.error,
	black: Theme.black,
	mainBlack: Theme.mainBlack,
	white: Theme.white,
	greyDark: Theme.greyDark,
	greyLight: Theme.greyLight,
	greyBorder: Theme.greyBorder,
	bgDark: Theme.bgDark,
	bgMedium: Theme.bgMedium,
	bgLight: Theme.bgLight,
};

export const getItemColor = (type: string) =>
	type === "activity" || type === "tour"
		? Colors.main3
		: type === "cuisine"
			? Colors.main4
			: type === "accommodation"
				? Colors.main1
				: type === "transport"
					? Colors.main2
					: Colors.black;



export const getItemLightColor = (color: string) =>
	color === Colors.main1
		? Colors.main1light
		: color === Colors.main2
			? Colors.main2light
			: color === Colors.main3
				? Colors.main3light
				: color === Colors.main4
					? Colors.main4light
					: Colors.bgDark;

// PDF/Photobook constants
export const DPI = 300;
export const SCALE = 1;
export const A4 = { width: 841.89 * SCALE, height: 595.276 * SCALE };
export const BLEED = 3 * 2.835 * SCALE; // 3mm in points
export const OVERLAP = 5 * 2.835 * SCALE; // 5mm in points
export const A4_UNSCALED = { width: 841.89 + BLEED, height: 595.276 + BLEED };
export const WRAP = 18 * 2.835; // 18mm in points
